import { render, staticRenderFns } from "./AccountMess.vue?vue&type=template&id=7f80c22e&scoped=true&"
import script from "./AccountMess.vue?vue&type=script&lang=js&"
export * from "./AccountMess.vue?vue&type=script&lang=js&"
import style0 from "./AccountMess.vue?vue&type=style&index=0&id=7f80c22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f80c22e",
  null
  
)

export default component.exports